import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";
import { useHistoryNavigate } from "../../../../hooks/useHistoryNavigate";
import useService from "../../../../hooks/useService";
import { IndexedDBService } from "../../../../services/indexed-db-service";
import { useAISummaryStore } from "../store/aiSummaryStore";

export default function useButtonActions() {
  const aiSummaryRepository = useService("repositories/ai-summary-repository");
  const { navigationCaseId, selectedSummaryNote, selectedSummaryNoteContent } = useAISummaryStore();
  const { historyNavigate, navigationHistoryService } = useHistoryNavigate();
  const currentUserService = inject("current-user-service");
  const userId = currentUserService?.user?.pk || currentUserService?.user?.id;
  const clientNotesDB = new IndexedDBService("ClientNotes", "notes");

  function getKey() {
    return `${userId}_new`;
  }

  function htmlToPlainText(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.innerText;
  }

  async function markNoteAsRead() {
    await aiSummaryRepository.patch(selectedSummaryNote?.uuid, {
      read_time: new Date(Date.now()).toISOString(),
    });
  }

  async function handleCopyNoteBtn() {
    const plainText = htmlToPlainText(selectedSummaryNoteContent);
    const clipboardItem = new ClipboardItem({
      "text/plain": new Blob([plainText], { type: "text/plain" }),
      "text/html": new Blob([selectedSummaryNoteContent], { type: "text/html" }),
    });
    await navigator.clipboard.write([clipboardItem]);
    if (selectedSummaryNote?.readTime === null) {
      await markNoteAsRead();
    }
    navigationHistoryService.save("client-detail", "/client-info/images");
    historyNavigate("client-detail", navigationCaseId, { triggerToast: true });
  }

  async function handleCreatNewNoteBtn() {
    clientNotesDB.save(getKey(), selectedSummaryNoteContent);
    if (selectedSummaryNote?.readTime === null) {
      await markNoteAsRead();
    }
    navigationHistoryService.save("client-detail", "/client-info/images");
    historyNavigate("client-detail", navigationCaseId, { openNotesAdd: true });
  }

  function handleDropdownButtonClick(item) {
    switch (item?.action) {
      case "COPY_NOTE":
        handleCopyNoteBtn();
        break;

      case "ADD_NOTE":
        handleCreatNewNoteBtn();
        break;

      default:
        break;
    }
  }

  return {
    handleCopyNoteBtn,
    handleDropdownButtonClick,
  };
}
